import { FormParams, FormParamValueType } from '@models/form';

export function findSettingValue<T extends FormParamValueType = string>(
    settingArray: FormParams = [],
    searchKey = ''
): T | undefined {
    if (!Array.isArray(settingArray)) {
        return undefined;
    }

    const setting = settingArray.find(({ key }) => key && key.toLowerCase() === searchKey.toLowerCase());

    if (setting) {
        return setting.value as T;
    }

    return undefined;
}
